import React from "react"
import classnames from "classnames"
import { MuteIcon, UnMuteIcon, LoadingSection } from "AtomicComponents"
import styles from "./VideoPlayer.less"
import debounce from 'AtomicUtils/debounce'
import checkVisible from 'AtomicUtils/checkVisible'
import { WINDOW } from "AtomicUtils/environment"

class VideoPlayer extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      muted: true,
      visible: props.visible || false,
      opacity: props.visible ? 1 : 0,
      height: props.height || 400
    }
  }

  componentDidMount() {
    const { getRef = () => {}, visible } = this.props
    getRef(this.video)
    if (!visible) {
      this._showOrHide()
      WINDOW.addEventListener("scroll", debounce(this._showOrHide, 250), {
        passive: true
      })
    }
  }

  componentDidUpdate(prevProp) {
    if (prevProp.height != this.props.height) {
      this.setState({
        height: this.props.height
      })
    }
  }

  componentWillUnmount() {
    const { visible } = this.props

    if (!visible) {
      WINDOW.removeEventListener("scroll", debounce(this._showOrHide,250), {
        passive: true
      })
    }
  }

  _handleSound = () => {
    const { muted } = this.state
    this.setState({
      muted: !muted
    })
  }

  _showOrHide = () => {
    const { visible } = this.state
    const { getRef = () => {}, src } = this.props
    if (this.videoParent){
      if (checkVisible(this.videoParent) && !visible){
        this.setState({
          visible: true,
          opacity: 0,
        }, () => {
          getRef(this.video)
          setTimeout(() => {
            this.setState({
              opacity: 1
            })
          }, 200);
        })
      }
      if (this.video && src) {
        let isPlaying = this.video.currentTime > 0 && !this.video.paused && !this.video.ended && this.video.readyState > 2
        if (checkVisible(this.video)) {
          if (!isPlaying) this.video.play()
        } else {
          if (isPlaying) this.video.pause()
        }
      }
    }

  }

  render() {
    const {
      src,
      loop = true,
      autoPlay = true,
      soundDirection = "left",
      poster,
      showSoundIcon = false,
      onTimeUpdate,
      onEnded,
      onCanPlay,
      calculatedHeight=false
    } = this.props

    const { muted, visible, height, opacity } = this.state

    let extraProps = {}
    if (loop) extraProps.loop = true
    if (autoPlay) extraProps.autoPlay = true
    if (muted) extraProps.muted = true
    if (onTimeUpdate) extraProps.onTimeUpdate = onTimeUpdate
    if (onCanPlay) extraProps.onCanPlay = onCanPlay
    if (onEnded) extraProps.onEnded = onEnded
    if (calculatedHeight && height) extraProps.style = {
      height: height,
      width: "100%"
    }

    return (
      <div
        ref={c => this.videoParent = c}
        className={classnames({
          [styles.VideoPlayer]: true
        })}>
        {!visible &&
          <LoadingSection
            visible
            height={height}
          />
        }
        {visible &&
          <div
            className={classnames({
              [styles.VideoParent]: true
            })}
            style={{
              opacity: opacity === 0 ? 0.8 : 1
            }}
          >
            <video
              ref={c => this.video = c}
              className={classnames({
                [styles.Video]: true
              })}
              playsInline
              src={src}
              poster={poster}
              type="video/mp4"
              {...extraProps}
            >
            </video>
            {showSoundIcon &&
              <div
              className={classnames({
                [styles.Icon]: true,
                [styles.IconRight]: soundDirection === "right",
                [styles.IconLeft]: soundDirection === "left"
              })}
              onClick={this._handleSound}>
                {muted && <MuteIcon />}
                {!muted && <UnMuteIcon />}
              </div>
            }
          </div>
        }
      </div>
    )
  }
}


export default VideoPlayer



// WEBPACK FOOTER //
// ./src/AtomicContainers/VideoPlayer/VideoPlayer.jsx